import axios from "axios";

export type UploadFlow = "adventure" | "portfolio" | "community-upload" | "customer-upload" | "logo" | "trial" | "social" | null;

/** When saving an edited itinerary image, server derives `--vN` names and may remove the prior edited version only. */
export type ItineraryImageEditMeta = {
  isEditedVersion?: boolean;
  editedFromAssetId?: string | null;
};

export default {
  // Uploads an image blob to the server.
  // Note: This is currently used by the adventure UploadPhotoForm (the profile and community icon use their own flow)
  async uploadItineraryImageBlob(
    imageBlobToUpload,
    processAsset: boolean | null,
    clientFileName: string,
    flow: UploadFlow,
    abortControllerSignal?: AbortSignal,
    editMeta?: ItineraryImageEditMeta
  ): Promise<string | null> {
    // Note: We can now pass in a crop anchor (ex. &cropAnchor=Left)
    let postUrl = `${import.meta.env.VITE_API_URL}/images?type=itinerary&flow=${flow}`;
    if (processAsset != null) postUrl += `&processAsset=${processAsset}`;
    if (editMeta?.isEditedVersion) {
      postUrl += `&isEditedVersion=true`;
      if (editMeta.editedFromAssetId) {
        postUrl += `&editedFromAssetId=${encodeURIComponent(editMeta.editedFromAssetId)}`;
      }
    }
    const formData = new FormData();
    formData.append("file", imageBlobToUpload, clientFileName);

    try {
      var result = await axios.post(postUrl, formData, {
        signal: abortControllerSignal,
      });
    } catch (error) {
      if (error.name === "CanceledError") {
        console.info("uploadItineraryImageBlob: Request is aborted");
      } else {
        throw error;
      }
    }
    // return the uploaded file's server-side identifier
    return result?.data?.[0];
  },
};
